// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__8ap1C","code":"PageNotFound_code__Zp3yw","message":"PageNotFound_message__w9EBG"};